module.exports = __webpack_public_path__ + "static/media/13_3.f64c3a94.png";